import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import Pagination from "react-js-pagination";
import moment from "moment";
import swal from "sweetalert";
import { apiService } from "../../service/api.service";
import { ThreeDotSpinner } from "../loader";
import { ITEMS_PER_PAGE, dateFormate } from "../../config/config";
import CopyToClipboard from "react-copy-to-clipboard";

const PLAN_TYPES = [
  { label: "All Plans", value: "" },
  { label: "Social-Gated", value: "social-gated" },
  { label: "Token-Gated", value: "token-gated" }
];

const formatTypeLabel = (type) => {
  if (type === "token-gated") return "Token-Gated";
  if (type === "social-gated") return "Social-Gated";
  return type || "-";
};

const formatAmount = (value) => {
  const number = Number(value || 0);
  return number.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const PlanPayments = () => {
  const [page, setPage] = useState(1);
  const [records, setRecords] = useState({ list: [], total: 0, limit: ITEMS_PER_PAGE });
  const [loader, setLoader] = useState(false);
  const [typeFilter, setTypeFilter] = useState(PLAN_TYPES[0].value);
  const [searchInput, setSearchInput] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [copied, setcopied] = useState(false);

  const formatAddress = (addr) => {
    return `${addr.substring(0, 4)}...${addr.substring(addr.length - 4)}`;
  };
  const copytooltip = (
    <Tooltip id="tooltip">{copied ? "Copied" : "Copy"}</Tooltip>
  );

  const setcopytext = () => {
    setTimeout(() => {
      setcopied(false);
    }, "1000");
  };

  const fetchPlanPayments = async () => {
    setLoader(true);
    try {
      const params = {
        page: page - 1,
        limit: ITEMS_PER_PAGE
      };

      if (typeFilter) {
        params.type = typeFilter;
      }

      if (appliedSearch) {
        params.search = appliedSearch;
      }

      const response = await apiService.getPlanPayments(params);
      const payload = response?.data?.data;
      setRecords({
        list: payload?.list || [],
        total: payload?.total || 0,
        limit: payload?.limit || ITEMS_PER_PAGE
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear();
          window.location.href = "/";
        });
      } else {
        swal({
          icon: "error",
          text: error?.response?.data?.message || error?.message || "Unable to fetch plan payments.",
          button: "OK"
        });
      }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchPlanPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, typeFilter, appliedSearch]);

  const handleSearch = (event) => {
    event.preventDefault();
    setPage(1);
    setAppliedSearch(searchInput.trim());
  };

  const handleTypeChange = (event) => {
    setTypeFilter(event.target.value);
    setPage(1);
  };

  const handleClearFilters = () => {
    setSearchInput("");
    setAppliedSearch("");
    setTypeFilter(PLAN_TYPES[0].value);
    setPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const serialOffset = (page - 1) * (records?.limit || ITEMS_PER_PAGE);
  const list = records?.list || [];

  return (
    <div className="dashboard-main-area">
      {loader ? <ThreeDotSpinner /> : null}
      <Container fluid>
        <div className="dashboard-area-heading management-heading">
          <Row className="justify-content-center align-items-center mb-3">
            <Col md={12} lg={11}>
              <div className="heading-top-area">
                <div className="d-flex flex-column flex-md-row gap-3 align-items-md-center">
                  <h2 className="m-0">UGP Plan Payments</h2>
                  <span className="text-muted small">
                    Track all successful Social and Token gated plan purchases.
                  </span>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="pb-3 justify-content-center">
            <Col md={12} lg={11}>
              <div className="filter-top-area d-flex flex-column flex-lg-row gap-3">
                <Form className="flex-grow-1" onSubmit={handleSearch}>
                  <Row className="g-2">
                    <Col lg={8} md={12} className="search-area">
                      <Form.Group controlId="searchTerm">
                        <Form.Label>Search</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Email, wallet, referral, tx hash"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                        />
                      </Form.Group>
                       <Form.Group controlId="planType">
                        <Form.Label>Plan Type</Form.Label>
                        <Form.Select value={typeFilter} onChange={handleTypeChange}>
                          {PLAN_TYPES.map((option) => (
                            <option key={option.value || "all"} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={3} md={6}>
                      <Form.Group controlId="planType">
                        <Form.Label>Plan Type</Form.Label>
                        <Form.Select value={typeFilter} onChange={handleTypeChange}>
                          {PLAN_TYPES.map((option) => (
                            <option key={option.value || "all"} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col> */}
                    <Col lg={2} md={4} className="d-flex align-items-end">
                      <Button type="submit" className="w-100 submit-btn">
                        Search
                      </Button>
                    </Col>
                    <Col lg={2} md={4} className="d-flex align-items-end">
                      <Button  className="w-100  clearbtn" onClick={handleClearFilters}>
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>

          <Row className="pb-4 justify-content-center">
            <Col md={12} lg={11}>
              <div className="audit-request-box">
                <Table responsive="sm" bordered hover className="UserListTable">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Email / Phone</th>
                      <th>Wallet Address</th>
                      <th>Solana Wallet</th>
                      <th>Plan Type</th>
                      <th>Package</th>
                      <th>Amount Paid (USDC)</th>
                      <th>Referral Code</th>
                      <th>Tx Hash</th>
                      <th>Purchased On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.length ? (
                      list.map((entry, index) => (
                        <tr key={entry._id || index}>
                          <td>{serialOffset + index + 1}</td>
                          <td>{entry?.user?.phone_or_email || "N/A"}</td>
                          <td onClick={setcopytext}> {entry?.user?.wallet_address ? (
                            <>{formatAddress(entry?.user?.wallet_address)}</>
                          ) : (
                            <>-</>
                          )} <OverlayTrigger
                            placement="top"
                            overlay={copytooltip}
                          >
                              <CopyToClipboard
                                text={entry?.user?.wallet_address}
                                onCopy={() => setcopied(true)}
                              >
                                <i
                                  class="fa fa-clipboard"
                                  aria-hidden="true"
                                ></i>
                              </CopyToClipboard>
                            </OverlayTrigger> </td>
                          <td onClick={setcopytext}> {entry?.user?.custodial_solana_address ? (
                            <>{formatAddress(entry?.user?.custodial_solana_address)}</>
                          ) : (
                            <>-</>
                          )} <OverlayTrigger
                            placement="top"
                            overlay={copytooltip}
                          >
                              <CopyToClipboard
                                text={entry?.user?.custodial_solana_address}
                                onCopy={() => setcopied(true)}
                              >
                                <i
                                  class="fa fa-clipboard"
                                  aria-hidden="true"
                                ></i>
                              </CopyToClipboard>
                            </OverlayTrigger> </td>
                          <td>{formatTypeLabel(entry?.type)}</td>
                          <td>
                            {(entry?.totalCount || entry?.plan?.packageCount || 0)} games · {entry?.boostMultiplier || entry?.plan?.multiplier || "-"}x
                          </td>
                          <td>{formatAmount(entry?.amountPaid || entry?.planPrice)}</td>
                          <td>{entry?.referralCode || "-"}</td>
                          <td className="text-break" onClick={setcopytext}> {entry?.transactionHash ? (
                            <>{formatAddress(entry?.transactionHash)}</>
                          ) : (
                            <>-</>
                          )} <OverlayTrigger
                            placement="top"
                            overlay={copytooltip}
                          >
                              <CopyToClipboard
                                text={entry?.transactionHash}
                                onCopy={() => setcopied(true)}
                              >
                                <i
                                  class="fa fa-clipboard"
                                  aria-hidden="true"
                                ></i>
                              </CopyToClipboard>
                            </OverlayTrigger> </td>
                          <td>
                            {entry?.purchaseDate
                              ? moment(entry.purchaseDate).format(dateFormate)
                              : entry?.createdAt
                              ? moment(entry.createdAt).format(dateFormate)
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="no-dat-found-box">
                        <td colSpan={10}>
                          <img src={require("../../assets/images/no-data.svg").default} alt="no data" />
                          <h3 className="text-center text-light">No payments found</h3>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                {records?.total > records?.limit ? (
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={records?.limit || ITEMS_PER_PAGE}
                    totalItemsCount={records?.total || 0}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    prevPageText={"Prev"}
                    nextPageText={"Next"}
                  />
                ) : null}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default PlanPayments;
